import React from 'react'
import { Link } from "react-router-dom";


const NewsInfo = () => {
    return (
        <>
            <section className="bg-body section-space-less30">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-12 mb-30">
                            <div className="news-details-layout1">
                                <div className="position-relative mb-30">
                                    <img src="/assets/img/News.JPG" alt="news-details" className="img-fluid" />
                                    <div className="topic-box-top-sm">
                                        <div className="topic-box-sm color-cinnabar mb-20">News</div>
                                    </div>
                                </div>
                                <h2 className="title-semibold-dark size-c30">नॉर्मल इंसान को कितना दिया जाता है एनेस्थेसिया, कितनी ज्यादा डोज पर हो जाती है मौत?</h2>
                                <ul className="post-info-dark mb-30">
                                    <li>
                                        <a to="#">
                                            <span>By</span> Admin </a>
                                    </li>
                                    <li>
                                        <a to="#">
                                            <i className="fa fa-calendar" style={{ color: "black" }} aria-hidden="true" />Oct. 16, 2025</a>
                                    </li>
                                </ul>
                                <p>
                                    कर्नाटक की राजधानी बेंगलुरु से एक चौंकाने वाला मामला सामने आया है.
                                    <b style={{ color: "red" }}>
                                        यहां एक सर्जन पर अपनी ही पत्नी की हत्या का आरोप लगा है.
                                    </b>
                                    पुलिस के अनुसार, डॉक्टर ने अपनी पत्नी को इलाज के बहाने एनेस्थेसिया की ओवरडोज दी, जिससे उसकी मौत हो गई. यह घटना अप्रैल में हुई थी, लेकिन अब फोरेंसिक रिपोर्ट आने के बाद पूरा मामला अननेचुरल डेथ से मर्डर केस में बादल गया है.
                                </p>
                                <p>फोरेंसिक रिपोर्ट में महिला के शरीर में प्रोपोफॉल नामक दवा पाई गई है, जो एक इंट्रावेनस एनेस्थेटिक होती है और आमतौर पर ऑपरेशन के दौरान मरीज को बेहोश करने के लिए दी जाती है. इस घटना के बाद यह सवाल उठ रहा है कि आखिर एनेस्थेसिया की सामान्य मात्रा कितनी होती है और कितनी डोज देने पर यह जानलेवा साबित हो सकता है. ऐसे में चलिए आज हम आपको बताते हैं कि नॉर्मल इंसान को कितना एनेस्थेसिया दिया जाता है और कितनी डोज पर उसकी मौत हो सकती है.

                                </p>
                                <b style={{ color: "#008d7f" }}>क‍ितनी डाेज पर हो सकती है मौत?

                                </b>
                                <p>आमतौर पर सर्जरी में दी जाने वाली एनेस्थेसिया की मात्रा सुरक्षित मानी जाती है, लेकिन ओवरडोज की स्थिति में यह जानलेवा साबित हो सकती है. एक्सपर्ट्स के अनुसार, एक हेल्दी व्यक्ति में एनेस्थेसिया से मौत का खतरा 1 लाख लोगों में सिर्फ एक पर होता है. हालांकि मरीज को पहले से दिल, किडनी या फेफड़ों की बीमारी है तो उसका शरीर एनेस्थेसिया को सहन नहीं कर पाता है. इस स्थिति में थोड़ी सी ज्यादा मात्रा भी हार्ट अरेस्ट या ब्रेन ब्लीड जैसी स्थिति पैदा कर सकती है.</p>
                                <blockquote cite="#" className="bg-accent mt-50 mb-50">
                                    स्टार न्यूज़ नेटवर्क में, हम विविध विषयों पर विश्वसनीय, निष्पक्ष और समय पर समाचार प्रदान करने के लिए प्रतिबद्ध हैं। ब्रेकिंग हेडलाइन से लेकर गहन विश्लेषण तक, हम सुनिश्चित करते हैं कि हमारे दर्शक सूचित, जुड़े और सशक्त रहें।
                                </blockquote>
                                <div className="post-share-area mb-40 item-shadow-1">
                                    <p>You can share this post!</p>
                                    <ul className="social-default item-inline">
                                        <li>
                                            <Link to="https://www.youtube.com/@Starnewsnetworks88" target="_blank" className="pinterest">
                                                <i className="fa fa-youtube" aria-hidden="true" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="https://wa.me/917987667358" className="facebook" target="_blank">
                                                <i className="fa fa-whatsapp" aria-hidden="true" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="https://www.facebook.com/p/Star-News-Networks-61571596704367/" className="facebook" target="_blank">
                                                <i className="fa fa-facebook" aria-hidden="true" />
                                            </Link>
                                        </li>

                                    </ul>
                                </div>
                                {/* <div className="author-info p-35-r mb-50 border-all">
                                    <div className="media media-none-xs">
                                        <img src="/assets/img/author.jpg" alt="author" className="img-fluid rounded-circle" />
                                        <div className="media-body pt-10 media-margin30">
                                            <h3 className="size-lg mb-5">Star News Network</h3>
                                            <div className="post-by mb-5">By Admin</div>
                                            <p className="mb-15">
                                                सटीक, निष्पक्ष रिपोर्टिंग प्रदान करके समाचार के उपभोग के तरीके में परिवर्तन लाना, जिससे विश्वास पैदा हो और सूचित निर्णय लेने को प्रोत्साहन मिले।</p>
                                            <ul className="author-social-style2 item-inline">
                                                <li>
                                                    <a to="#" title="facebook">
                                                        <i className="fa fa-facebook" aria-hidden="true" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a to="#" title="twitter">
                                                        <i className="fa fa-twitter" aria-hidden="true" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a to="#" title="google-plus">
                                                        <i className="fa fa-youtube" aria-hidden="true" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a to="#" title="linkedin">
                                                        <i className="fa fa-instagram" aria-hidden="true" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a to="#" title="pinterest">
                                                        <i className="fa fa-whatsapp" aria-hidden="true" />
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="ne-sidebar sidebar-break-md col-lg-4 col-md-12">
                            <div className="sidebar-box">
                                <div className="topic-border color-cod-gray mb-30">
                                    <div className="topic-box-lg color-cod-gray">Stay Connected</div>
                                </div>
                                <ul className="stay-connected overflow-hidden">
                                    <li className="facebook">
                                        <Link to="https://www.facebook.com/p/Star-News-Networks-61571596704367/" target="_blank">
                                            <i className="fa fa-facebook" aria-hidden="true" />
                                        </Link>
                                    </li>
                                    <li className="twitter">
                                        <Link to="https://wa.me/917987667358" target="_blank">
                                            <i className="fa fa-whatsapp" aria-hidden="true" />
                                        </Link>
                                    </li>
                                    <li className="linkedin">
                                        <Link to="https://www.youtube.com/@Starnewsnetworks88" target="_blank">
                                            <i className="fa fa-youtube" aria-hidden="true" />
                                        </Link>
                                    </li>
                                </ul>
                            </div>

                            <div className="sidebar-box">
                                <div className="topic-border color-cod-gray mb-5">
                                    <div className="topic-box-lg color-cod-gray">Recent News</div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6 col-md-4 col-sm-6 col-6">
                                        <div className="mt-25 position-relative">
                                            <div className="topic-box-top-xs">
                                                <div className="topic-box-sm color-cod-gray mb-20">News</div>
                                            </div>
                                            <a to="single-news-1.html" className="mb-10 display-block img-opacity-hover">
                                                <img src="/assets/img/news/news171.jpg" alt="ad" className="img-fluid m-auto width-100" />
                                            </a>
                                            <h3 className="title-medium-dark size-md mb-none">
                                                <a to="single-news-1.html">ट्रेन में अब बेडरोल में कंबल के साथ मिलेगा कवर: जयपुर-असर्वा एक्सप्रेस के एसी </a>
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-4 col-sm-6 col-6">
                                        <div className="mt-25 position-relative">
                                            <div className="topic-box-top-xs">
                                                <div className="topic-box-sm color-cod-gray mb-20">News</div>
                                            </div>
                                            <a to="single-news-1.html" className="mb-10 display-block img-opacity-hover">
                                                <img src="/assets/img/news/news172.jpg" alt="ad" className="img-fluid m-auto width-100" />
                                            </a>
                                            <h3 className="title-medium-dark size-md mb-none">
                                                <a to="single-news-1.html">नॉर्मल इंसान को कितना दिया जाता है एनेस्थेसिया, कितनी ज्यादा डोज पर हो जाती है मौत?</a>
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-4 col-sm-6 col-6">
                                        <div className="mt-25 position-relative">
                                            <div className="topic-box-top-xs">
                                                <div className="topic-box-sm color-cod-gray mb-20">News</div>
                                            </div>
                                            <a to="single-news-1.html" className="mb-10 display-block img-opacity-hover">
                                                <img src="/assets/img/news/news173.jpg" alt="ad" className="img-fluid m-auto width-100" />
                                            </a>
                                            <h3 className="title-medium-dark size-md mb-none">
                                                <a to="single-news-1.html">नेस्ले की आय में वृद्धि और 16,000 नौकरियों में कटौती के कारण 2008 </a>
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-4 col-sm-6 col-6">
                                        <div className="mt-25 position-relative">
                                            <div className="topic-box-top-xs">
                                                <div className="topic-box-sm color-cod-gray mb-20">News</div>
                                            </div>
                                            <a to="single-news-1.html" className="mb-10 display-block img-opacity-hover">
                                                <img src="/assets/img/news/news174.jpg" alt="ad" className="img-fluid m-auto width-100" />
                                            </a>
                                            <h3 className="title-medium-dark size-md mb-none">
                                                <a to="single-news-1.html">भारत ने गुटनिरपेक्ष आंदोलन की बैठक में फिलिस्तीन मुद्दे के दोहराया।</a>
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-4 col-sm-6 col-6">
                                        <div className="mt-25 position-relative">
                                            <div className="topic-box-top-xs">
                                                <div className="topic-box-sm color-cod-gray mb-20">News</div>
                                            </div>
                                            <a to="single-news-1.html" className="mb-10 display-block img-opacity-hover">
                                                <img src="/assets/img/news/news175.jpg" alt="ad" className="img-fluid m-auto width-100" />
                                            </a>
                                            <h3 className="title-medium-dark size-md mb-none">
                                                <a to="single-news-1.html">Rosie Huntington Whitl Habits Career Art.Rosie
                                                    TBeauty Habits.</a>
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-4 col-sm-6 col-6">
                                        <div className="mt-25 position-relative">
                                            <div className="topic-box-top-xs">
                                                <div className="topic-box-sm color-cod-gray mb-20">News</div>
                                            </div>
                                            <a to="single-news-1.html" className="mb-10 display-block img-opacity-hover">
                                                <img src="/assets/img/news/news176.jpg" alt="ad" className="img-fluid m-auto width-100" />
                                            </a>
                                            <h3 className="title-medium-dark size-md mb-none">
                                                <a to="single-news-1.html">Rosie Huntington Whitl Habits Career Art.Rosie
                                                    TBeauty Habits.</a>
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default NewsInfo